//product slider start
if(window.innerWidth < 767) {
    var swiper = new Swiper(".single-product__img-swiper", {
        slidesPerView: 1.1,
        spaceBetween: 5,
        loop: true,                         
        centeredSlides : true, 
        pagination: {
            el: ".single-product__img-swiper-nav",
            clickable: true,
        },
    });
}
//product slider end

//product btn fixed position start
// Function to check if the target block is scrolled up
function addClassIfScrolledUp() {
    const targetBlock = document.querySelector('.single-product__info-product-soldout-holder');
    const targetBlockInner = document.querySelector('.single-product__info-product-soldout');
  
    // Get the position of the block relative to the viewport
    const rect = targetBlock.getBoundingClientRect();
    // Check if the block is above the viewport (scrolled up)
    if (rect.bottom < 0) {
        targetBlockInner.classList.add('scrolled-up');
    } else {
        targetBlockInner.classList.remove('scrolled-up');
    }
}
  
function addClassIfScrolledUp2() {
    const targetBlock = document.querySelector('.single-product__info-btn-holder');
    const targetBlockInner = document.querySelector('.single-product__info-btn');

    // Get the position of the block relative to the viewport
    const rect = targetBlock.getBoundingClientRect();
    // Check if the block is above the viewport (scrolled up)
    if (rect.bottom < 0) {
        targetBlockInner.classList.add('scrolled-up');
    } else {
        targetBlockInner.classList.remove('scrolled-up');
    }
}

// Attach the event listener to the window's scroll event
/*if(window.innerWidth < 768) {
    window.addEventListener('scroll', addClassIfScrolledUp);
    window.addEventListener('scroll', addClassIfScrolledUp2);
}*/
//product btn fixed position end

//play video start
const playButton = document.querySelectorAll(".playButton");

playButton.forEach((playButtonElem) => {
  playButtonElem.onclick = function () {
    this.style.display = "none";
    console.log(this.classList);
    let videoProd = this.previousElementSibling;
    console.log(videoProd);
    videoProd.play();
  };
});
//play video end